import Cookies from 'js-cookie'
import { PUBLIC_GDPR_COOKIE_NAME, PUBLIC_GDPR_COOKIE_DOMAIN } from '$env/static/public'

export const CONSENT_COOKIE_NAME = PUBLIC_GDPR_COOKIE_NAME || 'gdpr-consent-google-tagmanager'

/**
 * @returns {boolean|undefined}
 */
export const getConsentCookieValue = () => {
    const value = Cookies.get(CONSENT_COOKIE_NAME)

    if (typeof value === 'string') {
        return value === 'true'
    } else {
        return undefined
    }
}

export const setConsentCookieValue = value => {
    const cookieOptions = { expires: 1000 }

    if (PUBLIC_GDPR_COOKIE_DOMAIN) {
        cookieOptions.domain = PUBLIC_GDPR_COOKIE_DOMAIN
    }

    Cookies.set(CONSENT_COOKIE_NAME, value.toString(), cookieOptions)
}
